import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserInfoContext } from "../../lib/contexts/UserInfoContext";
import { isSuperAdmin, isUserAuthorized } from "@common/domain/auth";

export const SuperAdminAuth = () => {
  const navigate = useNavigate();
  const { userInfo } = useUserInfoContext();

  useEffect(() => {
    if (userInfo) {
      if (!isUserAuthorized(userInfo.groups)) {
        navigate("/unauthorized");
      } else if (!isSuperAdmin(userInfo.groups)) {
        navigate("/");
      }
    }
  }, [userInfo, navigate]);

  if (!userInfo || !isSuperAdmin(userInfo.groups)) {
    return null;
  }

  return <Outlet />;
};

export default SuperAdminAuth;
